export default __webpack_public_path__ + "static/media/transmission01.bfc1c9ec.mp3";